import React from 'react';
import useAutosize from 'hooks/useAutosize';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import CriteriaList from '../CriteriaList';
import AnswerCorrectness from './AnswerCorrectness';

const GraderFeedback = props => {
  const {
    preview,
    answerId,
    handleCorrectClick,
    handleFeedbackUpdate,
    correctAnswer,
    feedback,
    criteriaRatings,
    ratingOptions,
    feedbackCriteriaPresent,
  } = props;
  const criteriaListData = {
    ratingOptions,
    criteriaRatings,
    preview,
    id: answerId,
  };
  const autoSizeRef = useAutosize();
  return (
    <div>
      {!preview && (
        <div className="VideoResponseModal-score mb-16">
          <div className="mb-16">
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>
              {t('progress.report_card.correct_answer')}
            </Text>
          </div>
          <div>
            <label htmlFor={`${answerId}.correct`}>
              <input
                defaultChecked={correctAnswer === 'true'}
                id={`${answerId}.correct`}
                name="correct"
                onChange={handleCorrectClick}
                type="radio"
                value="true"
              />
              <span className="ml-8">{t('grades.correct')}</span>
            </label>
          </div>
          <div>
            <label htmlFor={`${answerId}.incorrect`}>
              <input
                defaultChecked={correctAnswer === 'false'}
                id={`${answerId}.incorrect`}
                name="correct"
                onChange={handleCorrectClick}
                type="radio"
                value="false"
              />
              <span className="ml-8">{t('grades.incorrect')}</span>
            </label>
          </div>
        </div>
      )}
      {preview && (
        <div className="VideoResponseModal-score mb-16">
          <div className="mb-16">
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>{t('grades.result')}</Text>
          </div>
          <AnswerCorrectness correctAnswer={correctAnswer} />
        </div>
      )}
      <div className="VideoResponseModal-graderFeedback mb-16">
        <div className="mb-16">
          <Text variant={TEXT_VARIANTS.BODY_BOLD}>
            {!feedbackCriteriaPresent && preview
              ? t('progress.report_card.feedback')
              : t('grades.feedback.comments')}
          </Text>
        </div>
        {preview && (
          <div>{feedback || <em>{t('grades.feedback.none_provided')}</em>}</div>
        )}
        {!preview && (
          <textarea
            ref={autoSizeRef}
            className="VideoResponseModal-feedbackInput d-b w-fill"
            onChange={handleFeedbackUpdate}
            placeholder={t('grades.feedback.provide_feedback')}
            type="text"
            defaultValue={feedback}
          />
        )}
      </div>
      {feedbackCriteriaPresent && <CriteriaList data={criteriaListData} />}
    </div>
  );
};

export default GraderFeedback;
